exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.split[data-v-31c95163] {\n  width: 20%;\n}\n.flex[data-v-31c95163] {\n  align-items: center;\n}\n.content-tlist[data-v-31c95163] {\n  border: none;\n}\n", ""]);

// exports
